import prepareComponent from "@bluframe/grapple/prepareComponent";
import useReviews from "hooks/useReviews";
import useUser from "hooks/useUser";
import { memo } from "react";
import Main from "./Main";
const usePrepareComponent = () => {
    const { isAdmin, isEditor } = useUser();
    const { setIMDbId } = useReviews();
    return {
        isAdmin,
        isEditor,
        setIMDbId
    };
};
export default prepareComponent(usePrepareComponent)(memo(Main));
